import { TableContextProvider } from "contexts/TableContext";
import useSuperAdmin from "hooks/useSuperAdmin";
import GameNetworkExclusionsTable from "./components/GameNetworkExclusionsTable";

const GameNetworkExclusions = () => {
  document.title = "Gamelight - Game Network Exclusions";

  const isSuperAdmin = useSuperAdmin();

  if (!isSuperAdmin) {
    return <></>;
  }

  return (
    <TableContextProvider>
      <GameNetworkExclusionsTable />
    </TableContextProvider>
  );
};

export default GameNetworkExclusions;
